import {
  AssetPresentationRatioEnum,
  getWidthByHeight,
  KuxImages,
  getResizerUrl,
  KuxImage,
  getTypeByTypeName,
} from '@kaltura-ott/tvpil';

/**
 * Get dimensions and url of the image by ratio
 * @category Utils
 *
 * @param height: number
 * @param imageRatio: AssetPresentationRatioEnum
 * @param images: KuxImages
 * @param quality: number
 */
export const getImageByHeight = (
  height: number,
  imageRatio: AssetPresentationRatioEnum,
  images: KuxImages,
  quality?: number,
): {
  url?: string;
  width: number;
  height: number;
} => {
  const originImage = images[imageRatio];
  const width = Math.ceil(getWidthByHeight(height, imageRatio));
  return {
    url: originImage && getResizerUrl(originImage.url, height, width, quality),
    width,
    height,
  };
};

/**
 * Get dimensions and url of the image by imageType
 * @param height
 * @param imageTypeName
 * @param images
 * @param quality
 */
export const getImageByHeightV2 = (
  height: number,
  imageTypeName: string,
  images: KuxImages,
  quality?: number,
): {
  url?: string;
  width?: number;
  height: number;
} => {
  const type = getTypeByTypeName(imageTypeName);
  const originImage = type ? (images[type.id] as KuxImage) : undefined;
  const width = type ? Math.ceil(getWidthByHeight(height, type.ratio)) : undefined;
  return {
    url: originImage && getResizerUrl(originImage.url, height, width, quality),
    width,
    height,
  };
};
